module.exports = __webpack_public_path__ + "static/media/sv.7aecb115.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sv.svg
// module id = 1038
// module chunks = 0